export const reOrgTypeConstants = {
	GetPaged: {
		SUCCESS : 'GET_PAGED_ORG_TYPE_SUCCESS',
		REQUEST : 'GET_PAGED_ORG_TYPE_REQUEST',
		FAILURE : 'GET_PAGED_ORG_TYPE_FAILURE'
	},
	GetPagedAll: {
		REQUEST : 'GET_PAGED_ALL_ORG_TYPE_REQUEST',
		SUCCESS : 'GET_PAGED_ALL_ORG_TYPE_SUCCESS',
		FAILURE : 'GET_PAGED_ALL_ORG_TYPE_FAILURE'
	},
	GetPagedAudit: {
		REQUEST : 'GET_AUDIT_PAGED_ORG_TYPE_REQUEST',
		SUCCESS : 'GET_AUDIT_PAGED_ORG_TYPE_SUCCESS',
		FAILURE : 'GET_AUDIT_PAGED_ORG_TYPE_FAILURE'
	},
	GetList: {
		REQUEST : 'GET_LIST_ORG_TYPE_REQUEST',
		SUCCESS : 'GET_LIST_ORG_TYPE_SUCCESS',
		FAILURE : 'GET_LIST_ORG_TYPE_FAILURE'
	},
	Create: {
		REQUEST : 'CREATE_ORG_TYPE_REQUEST',
		SUCCESS : 'CREATE_ORG_TYPE_SUCCESS',
		FAILURE : 'CREATE_ORG_TYPE_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_ORG_TYPE_REQUEST',
		SUCCESS : 'DELETE_ORG_TYPE_SUCCESS',
		FAILURE : 'DELETE_ORG_TYPE_FAILURE'
	},
	Update: {
		REQUEST : 'UPDATE_ORG_TYPE_REQUEST',
		SUCCESS : 'UPDATE_ORG_TYPE_SUCCESS',
		FAILURE : 'UPDATE_ORG_TYPE_FAILURE'
	},
	Restore: {
		REQUEST : 'RESTORE_ORG_TYPE_REQUEST',
		SUCCESS : 'RESTORE_ORG_TYPE_SUCCESS',
		FAILURE : 'RESTORE_ORG_TYPE_FAILURE'
	},
	CLEAR: 'CLEAR_ORG_TYPE'
}